import { defineEntity, number, string, object, boolean } from '~/prix'
import sql from '~/prix/utils/sql'

const courseProductEntity = defineEntity({
  key: 'courseProduct',
  title: 'Cursos EAD',
  sources: ['olap', 'oltp'],
  schema: object({
    id: number().label('ID', 'Identificador', 'Código'),
    productCode: string().label('Código do produto'),
    portfolioSasCode: string().label('Código SAS portfólio'),
    sasOfferingCode: string().label('Código SAS disponibilização'),
    focoPortfolioCode: string().label('Código FOCO portfólio'),
    focoOfferingCode: string().label('Código FOCO disponibilização'),
    productType: number().label('Tipo do produto'),
    productName: number().label('Nome do produto'),
    isActivePortfolio: boolean().label('Ativo no portfolio atual do SEBRAE'),
    cnpjCount: number().label('Quantidade de CNPJs'),
  }),
})

export const courseProductPropertyMap = {
  id: sql`course_product.id`,
  productCode: sql`course_product.product_code`,
  portfolioSasCode: sql`course_product.portfolio_sas_code`,
  sasOfferingCode: sql`course_product.sas_offering_code`,
  focoPortfolioCode: sql`course_product.foco_portfolio_code`,
  focoOfferingCode: sql`course_product.foco_offering_code`,
  productType: sql`course_product.product_type`,
  productName: sql`course_product.product_name`,
  isActivePortfolio: sql`course_product.is_active_portfolio`,
  cnpjCount: sql`course_product.cnpj_count`,
}

export default courseProductEntity
